import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import get from 'lodash/get';
import { ReactElement, useState } from 'react';
import { Control, Controller, FieldErrors, FieldValues, Path } from 'react-hook-form';

import AvatarUpload from '~/ui/components/common/AvatarUpload';
import { ACCEPTABLE_IMAGE_IMAGES_TYPES_HELPER_TEXT } from '~/ui/constants/common';
import { isFile } from '~/utils/file';
import PrivateImage from '../../common/PrivateImage';

import styles from './AvatarUpload.module.scss';

interface IProps<TFieldValues extends FieldValues = FieldValues> {
  control: Control<TFieldValues>;
  errors: FieldErrors;
  name: string;
  label?: string;
  isPhoto?: boolean;
}

const AvatarUploadComponent = <TFieldValues extends FieldValues = FieldValues>({
  control,
  isPhoto,
  errors,
  name,
  label = '',
}: IProps<TFieldValues>): ReactElement => {
  const [uploadError, setUploadError] = useState('');
  const error = get(errors, `${name}.message`, '');

  return (
    <Controller
      control={control}
      name={name as Path<TFieldValues>}
      render={({ field: { value, onChange } }) => (
        <FormControl component="fieldset" className={styles.uploadControl} fullWidth>
          <FormLabel component="legend" className={styles.label}>
            {label}
          </FormLabel>
          <AvatarUpload
            helperText={!error && !uploadError && ACCEPTABLE_IMAGE_IMAGES_TYPES_HELPER_TEXT}
            contentTitle={isPhoto ? 'Photo' : 'Logo'}
            value={value}
            onUpload={file => {
              onChange(file);
              setUploadError('');
            }}
            filePreview={
              <div className={styles.imagePreview}>
                <PrivateImage
                  src={isFile(value) ? URL.createObjectURL(value) : value}
                  className={styles.image}
                  alt="Preview"
                />
              </div>
            }
            onRemove={() => onChange('')}
            onError={err => setUploadError(err)}
          />
          {uploadError && <FormHelperText error>{uploadError}</FormHelperText>}
          {error && <FormHelperText error>{error.toString()}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};

export default AvatarUploadComponent;
